import pubSub from '../utility/pub-sub';
import {
  VIDEO_PLAY,
  VIDEO_STOP,
  VIDEO_FINISH,
  PLATFORM_VIDEO_PLAY,
  TOGGLE_PROMOBOX_EVENT,
} from '../utility/constants';

class YoutubeVideo {
  $videos: JQLite;
  VIDEO_NAME: string;
  players: any[];

  constructor() {
    this.VIDEO_NAME = 'js-youtube-video';
    this.$videos = $(`.${this.VIDEO_NAME}`);
    this.players = [];
  }

  init() {
    if (this.$videos.length) {
      $.getScript('https://www.youtube.com/iframe_api', () => {
        // Create ID if not exist
        this.$videos.each((index, video) => {
          if (!video.id) {
            video.setAttribute('id', this.VIDEO_NAME + '-' + index + '');
          }
        });

        // When YT loaded create instance for each YT Player
        if ((<any>window).YT) {
          (<any>window).YT.ready(() =>
            this.$videos.each(this.createYTInstance.bind(this))
          );
        }

        // Subscribe to all Platform videos (JWPlayer) if some of them start to play
        pubSub.subscribe(PLATFORM_VIDEO_PLAY, this.stopAll.bind(this));

        // Stop video inside Promobox Accordion Modal component when modal/accordion close
        pubSub.subscribe(TOGGLE_PROMOBOX_EVENT, data => {
          if (!data.isPromoboxModalOpen) {
            const promoboxVideo = $(data.element).find(`.${this.VIDEO_NAME}`);
            const videoId = $(promoboxVideo).attr('id');
            this.players.forEach(playerVideo => {
              const iframeId = playerVideo.getIframe().id;
              if (
                iframeId &&
                iframeId === videoId &&
                playerVideo.hasOwnProperty('stopVideo')
              ) {
                return playerVideo.stopVideo();
              }
            });
          }
        });
      })
    }
  }

  /**
   * When video is ready Youtube APi run this callback to have control over video
   * @param video Youtube Video Iframe instance
   * @param autoplay 0-false 1-true
   * @param loop 0-false 1-true
   * @param mute 0-false 1-true
   */
  onPlayerReady(video: any, autoplay: number, loop: number, mute: number) {
    if (mute) {
      video.mute();
    }

    video.setLoop(loop === 1);

    if (autoplay === 1) {
      video.playVideo();
    }
  }

  /**
   * Callback for Youtube actions such as play, pause, ...
   * @param youtubeVideo
   * @param videoStatus playing, paused, ended
   */
  onPlayerStateChange(youtubeVideo: any, videoStatus: number) {
    var currentPlayerId = $(youtubeVideo.getIframe()).attr('id');

    // Notify listeners that youtube video play
    // @ts-ignore
    if (videoStatus === window['YT'].PlayerState.PLAYING) {
      this.players.forEach(video => {
        const iframeId = video.getIframe().id;
        if (
          iframeId &&
          iframeId !== currentPlayerId &&
          video.hasOwnProperty('stopVideo')
        ) {
          video.stopVideo();
        }
      });
      pubSub.publish(VIDEO_PLAY, {
        currentPlayerId
      });
    }

    // Notify listeners that youtube video is paused
    // @ts-ignore
    if (videoStatus === window['YT'].PlayerState.PAUSED) {
      pubSub.publish(VIDEO_STOP, {
        currentPlayerId
      });
    }

    // Notify listeners that youtube video is ended
    // @ts-ignore
    if (videoStatus === window['YT'].PlayerState.ENDED) {
      pubSub.publish(VIDEO_FINISH, {
        currentPlayerId
      });
    }
  }

  setVideoId() {
    const minVal = 100;
    const maxVal = 999;

    return Math.round(minVal + Math.random() * (maxVal - minVal)).toString();
  }

  /**
   * Create YT API instance
   * @param index - loop index number or null
   * @param video - video holder element
   * @returns YT player instance
   */
  createYTInstance(index: number, video: HTMLBaseElement) {
    let isIdExist = video.hasAttribute('id');

    if (!isIdExist) {
      video.setAttribute('id', `${this.VIDEO_NAME}-${this.setVideoId()}`);
    }
    let player: any = null;
    let playBtn = null;
    let pauseBtn = null;
    let context = null;

    const elementId = video.id;
    const youtubeId = video.getAttribute('data-youtubeID');
    // Get context of video since we cta that opens modal with another cta
    context = video.closest('.js-video-context');

    if (context) {
      if (context.querySelectorAll('.js-pause-youtube')) {
        pauseBtn = context.querySelectorAll('.js-pause-youtube');
      }

      if (context.querySelectorAll('.js-play-youtube')) {
        playBtn = context.querySelectorAll('.js-play-youtube')[0];
      }
    }

    // Get player options
    const controls = parseInt($(video).attr('data-controls'), 10);
    const autoplay = parseInt($(video).attr('data-autoplay'), 10);
    const mute = parseInt($(video).attr('data-mute'), 10);
    const loop = parseInt($(video).attr('data-loop'), 10);

    const element = document.getElementById(elementId);

    // @ts-ignore
    player = new window['YT'].Player(element, {
      videoId: youtubeId,
      playerVars: {
        controls,
        rel: 0
      },
      events: {
        onReady: (e: Event) => this.onPlayerReady(e.target, autoplay, loop, mute),
        // @ts-ignore
        onStateChange: (e) => this.onPlayerStateChange(e.target, e.data)
      }
    });

    this.players.push(player);

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        player.playVideo();
        pubSub.publish(VIDEO_PLAY, {});
      });
    }

    if (pauseBtn) {
      Array.from(pauseBtn, (button: HTMLElement) => {
        button.addEventListener('click', () => {
          player.stopVideo();
        });
      });
    }
  }

  /**
   * Stop all youtube videos
   */
  stopAll() {
    this.players.forEach(video =>
      typeof video.stopVideo === 'undefined' ? null : video.stopVideo()
    );
  }

  /**
   * Return all initialized YouTube videos expose to other components
   * @returns {YT} - list of YouTube iframe api players
   */
  getAllPlayers() {
    return this.players;
  }
}

export default YoutubeVideo;
